<template>
    <v-dialog
            :value="!!value"
            :retain-focus="false"
            persistent
            max-width="800"
    >
        <v-form
                v-model="validForm"
                ref="form"
                @submit.prevent="submit"
        >
            <v-card
                    :loading="loading > 0"
                    :disabled="loading > 0"
            >
                <v-card-title class="grs-card-title px-0">
                    <span> {{ $t('subscription_class_form_title') }} </span>

                    <v-spacer></v-spacer>

                    <v-btn
                            text
                            small
                            icon
                            @click="$emit('close')"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="pb-0">
                    <UserSelect
                        v-model="value.user_id"
                        :label="$t('user')"
                        placeholder="نام و نام خانوادگی  یا شماره همراه"
                        className="ml-2"
                    ></UserSelect>

                    <v-autocomplete
                            v-model="value.subscription_class_id"
                            :items="activeSubscriptionClasses"
                            item-text="name"
                            item-value="id"
                            :label="$t('subscription_class')"
                    ></v-autocomplete>
                </v-card-text>

                <v-card-actions class="px-4 pb-4">
                    <v-spacer></v-spacer>

                    <v-btn
                            color="secondary"
                            text
                            class="px-4"
                            @click="$emit('close')"
                    >{{$t('cancel')}}</v-btn>

                    <v-btn
                            color="primary"
                            class="px-4"
                            type="submit"
                    >
                        {{$t('submit')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script>
    import { mapState, mapActions, mapGetters } from 'vuex';
    // Utils
    import { required } from '@/scripts/validationRules';
    import Service from "@/services/SubscriptionService";
    import UserSelect from './UserSelect.vue';

    export default {
        props: {
            item : {
                required: true
            }
        },
        components : {
            UserSelect
        },
        computed : {
            ...mapState({
                users: state => state.users.items
            }),
            ...mapState({
                subscriptionClasses: state => state.subscriptionClasses.items
            }),
            ...mapGetters({
                fetchingUsers: 'users/fetching',
                fetchingSubscriptionClasses: 'subscriptionClasses/fetching',
            }),
            activeSubscriptionClasses(){
                return this.subscriptionClasses.filter(subscriptionClass => !subscriptionClass.disabled_at)
            },
            activeUsers(){
                return this.users.filter(user => !user.disabled_at)
            }
        },
        data() {
            return {
                validForm: false,
                loading: 0,
                value : {...this.item},
                rules: {
                    required
                },

            }
        },
        created(){
            if(this.users.length <= 0){
                this.fetchUsers();
            }

            if(this.subscriptionClasses.length <= 0){
                this.fetchSubscriptionClasses();
            }
        },
        methods: {
            ...mapActions({
                fetchUsers: 'users/fetchUsers',
                fetchSubscriptionClasses: 'subscriptionClasses/fetch',
            }),

            async submit() {
                if(!this.validForm) {
                    return this.$refs.propertyBindingForm.validate();
                }

                try {
                    this.loading++;

                    let {
                        data
                    } = this.value.id ? await Service.update(this.value) : await Service.create(this.value);
                    this.$emit('submit', data);

                    this.$notify({
                        group: 'formGroup',
                        type: 'success',
                        title: 'بسته جدید با موفقیت فعال گردید.',
                    });

                } finally {
                    this.loading--;
                }

                this.$emit('close');


            }
        }
    }
</script>